const SPECIES_OPTIONS = [
  { value: 'cedar', labelKey: 'Cedar', fallback: '杉' },
  { value: 'pine', labelKey: 'Pine', fallback: '松' }
];

const normalizeSpeciesValue = (value) => {
  if (value === null || value === undefined) return '';
  const raw = String(value).trim();
  if (!raw) return '';
  const lower = raw.toLowerCase();
  if (lower === 'cedar' || lower === 'sugi' || raw === '杉') return 'cedar';
  if (lower === 'pine' || lower === 'matsu' || raw === '松') return 'pine';
  return raw;
};

const getSpeciesLabel = (value, t) => {
  const normalized = normalizeSpeciesValue(value);
  const match = SPECIES_OPTIONS.find((opt) => opt.value === normalized);
  if (match) {
    return t(match.labelKey) || match.fallback || match.labelKey;
  }
  return value || '';
};

export { SPECIES_OPTIONS, normalizeSpeciesValue, getSpeciesLabel };
